import { render, staticRenderFns } from "./process-search.vue?vue&type=template&id=6573a64c"
import script from "./process-search.vue?vue&type=script&lang=js"
export * from "./process-search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports